import axiosInstance from './axiosInstance';
import { BASE_URL } from '../Constants';

export const getModules = async () => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/modules`);
    // console.log('response.data', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching modules:', error);
    throw error;
  }
};

export const updateModule = async (moduleId, updatedModuleData) => {
  try {
    await axiosInstance.put(`${BASE_URL}/modules/${moduleId}`, updatedModuleData);
  } catch (error) {
    console.error('Error updating module:', error);
    throw error;
  }
};

export const insertModule = async (newModuleData) => {
  try {
    await axiosInstance.post(`${BASE_URL}/modules`, newModuleData);
  } catch (error) {
    console.error('Error inserting module:', error);
    throw error;
  }
};

export const getModulePermissionByRoleID = async (userRoleId) => {
  try {
      // console.log('userRoleId',userRoleId);
      const checkResponse = await axiosInstance.get(`${BASE_URL}/moduleUserRole/${userRoleId}`);
      return checkResponse.data.data;
  } catch (error) {
          console.error('Error creating or updating user roles:', error);
          throw error;
  }
};

export const getModulesItems = async () => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/modules/menu`);
    // console.log('Modules list data:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching menu items:', error);
    throw error;
  }
};

export const getModulesByIds = async (moduleIds) => {
  try {
    const response = await axiosInstance.post(`${BASE_URL}/modules/modulesByIds`, {moduleIds});
    return response.data;
  } catch (error) {
    console.error("Error in fetching the data", error.response ? error.response.data : error.message);
    throw error.response ? error.response.data : error;
  }
};

export const getModulesForPermissions = async () => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/modules/modulesForPermission`);
    return response.data;
  } catch (error) {
    console.error('Error fetching modules:', error);
    throw error;
  }
};